// extracted by mini-css-extract-plugin
export default {"SearchIcon":"styles_SearchIcon__tYtP2"};